(() => {
  'use strict';

  const pad = (n) => String(n).padStart(2, '0');

  const countdownTimer = document.querySelector('.nextdev--sale-strip--timer');
  if (!countdownTimer) return;

  // "Countdown length" in the theme editor: until midnight, or hours plus
  // "Extra minutes". A length starts from the full run on a visitor's first
  // view and the end is kept in the browser, so it keeps counting across
  // pages and visits; a different length starts over, and so does one that
  // has run out. A browser that keeps nothing starts from the full length on
  // every page. Until midnight, or a length of nothing, counts to midnight.
  const hours = parseInt(countdownTimer.dataset.hours, 10);
  const minutes = parseInt(countdownTimer.dataset.minutes, 10) || 0;
  const runMs = isNaN(hours) ? 0 : (hours * 60 + minutes) * 60000;
  // the key keeps the old name, and whole hours keep the old ending, so a
  // timer already running in a browser carries on rather than starting over
  const storeKey = 'nextdev-sale-line-end-' + (minutes ? hours + 'h' + minutes : hours);

  function getSecondsUntilEndOfDay() {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(24, 0, 0, 0);
    return Math.floor((endOfDay - now) / 1000);
  }

  function getSecondsUntilEndOfRun() {
    const now = Date.now();
    let end = 0;
    try { end = parseInt(localStorage.getItem(storeKey), 10) || 0; } catch (e) {}
    if (end <= now || end > now + runMs) {
      end = now + runMs;
      try { localStorage.setItem(storeKey, String(end)); } catch (e) {}
    }
    return Math.floor((end - now) / 1000);
  }

  const getSecondsLeft = runMs > 0 ? getSecondsUntilEndOfRun : getSecondsUntilEndOfDay;

  const hoursEl   = countdownTimer.querySelector('.nextdev--sale-strip--timer__hours');
  const minutesEl = countdownTimer.querySelector('.nextdev--sale-strip--timer__minutes');
  const secondsEl = countdownTimer.querySelector('.nextdev--sale-strip--timer__seconds');
  if (!hoursEl || !minutesEl || !secondsEl) return;

  let countdownSeconds = getSecondsLeft();

  function updateTimer() {
    hoursEl.textContent   = pad(Math.floor(countdownSeconds / 3600));
    minutesEl.textContent = pad(Math.floor((countdownSeconds % 3600) / 60));
    secondsEl.textContent = pad(countdownSeconds % 60);

    secondsEl.classList.remove('flash');
    void secondsEl.offsetWidth;
    secondsEl.classList.add('flash');

    if (countdownSeconds > 0) {
      countdownSeconds--;
    } else {
      countdownSeconds = getSecondsLeft();
    }
  }

  updateTimer();
  setInterval(updateTimer, 1000);
  countdownTimer.classList.remove('hidden');
})();